import { Link, useLocation } from "react-router";

import { FolderKanbanIcon } from "lucide-react";

import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";

import { PERMISSIONS } from "@/shared/lib/constants/permissions";

interface Props {
  permissions: string[];
}

export function DesktopNav({ permissions }: Props) {
  const location = useLocation();

  return (
    <NavigationMenu className="hidden md:flex" viewport={false}>
      <NavigationMenuList>
        {permissions.includes(PERMISSIONS.USER_PROJECTS_READ) && (
          <NavigationMenuItem>
            <NavigationMenuLink asChild className={navigationMenuTriggerStyle()} data-active={location.pathname.startsWith("/projects") ? true : undefined}>
              <Link to="/projects">
                <FolderKanbanIcon />
                Projects
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
